import { z } from "zod";

export enum DictionaryProductSchemaEnum {
	DictionaryProduct = "DictionaryProduct"
};

export const DictionaryProductSchema = z.object({
	"@id": z.string(), // "api/dictionary_products/1"
	"@type": z.string(), // "DictionaryProduct"
	famille: z.string(), // "APPAREILS"
	fournisseur: z.string(), // "Sennheiser"
	hb_brand_id: z.string(), // "1"
	hb_brand_libelle: z.string(), // "Sennheiser"
	hb_category_id: z.string(), // "1"
	hb_category_libelle: z.string(), // "Appareils auditifs"
	hb_product_id: z.string(), // "2645"
	hb_product_libelle: z.string(), // "Casque Sennheiser"
	hb_supplier_id: z.string(), // "1"
	hb_supplier_libelle: z.string(), // "Biotone Technologie médicale"
	id: z.number(), // 1
	libelle: z.string(), // "EMERALD 40 S 6c"
	marque: z.string(), // "REXTON"
}).describe(DictionaryProductSchemaEnum.DictionaryProduct);

export type DictionaryProduct = z.infer<typeof DictionaryProductSchema>;
